import {AvatarWithLabel} from '@/components/ui/avatar-label';
import {TooltipWrapper} from '@/components/ui/tooltip';
import type {Resident} from '@/services/graphqlHooks';
import residentStatuses from '@/translation/residentStatuses';
import {cn} from '@/utils/ui';

import {getResidentStatusClasses} from './residentsHelpers';

type ResidentOptionSource = Pick<
  Resident,
  'id' | 'personalNumber' | 'roomId' | 'avatar' | 'status' | 'name'
>;

export type ResidentOption = ResidentOptionSource & {
  fallbackText: string;
  value: string;
  label: string;
  keywords: string[];
};

export function toResidentOption(
  resident: ResidentOptionSource
): ResidentOption {
  return {
    fallbackText: `${resident.name.firstName[0]}${resident.name.lastName[0]}`,
    keywords: [resident.name.firstName, resident.name.lastName],
    label: `${resident.name.firstName} ${resident.name.lastName}`,
    value: resident.id,
    ...resident,
  };
}

export function renderResidentOption(option: ResidentOption) {
  return (
    <div className="flex flex-row items-center gap-2">
      <AvatarWithLabel
        src={option.avatar || undefined}
        fallback={option.fallbackText}
        label={option.label}
        color="primary"
        size="small"
        layout="inline"
      />
      <TooltipWrapper title={residentStatuses[option?.status || '']}>
        <span
          className={cn(
            'h-3 w-3 rounded-full',
            getResidentStatusClasses(option?.status)
          )}
        />
      </TooltipWrapper>
    </div>
  );
}
